import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import ModalCard from "../../../components/ModalCard";
import ModalCardWithHeaderFooter from "../../../components/Cards/ModalCardWithHeaderFooter";
import InputPreview from "../../../components/Input/InputPreview";
import { blackShade19, border25 } from "../../../configs/styles/muiThemes";
import ImagePreview from "../../../components/Input/ImagePreview";

function VariantDataPreviewPopup({ openModal, setOpenModal, product }) {
  return (
    <ModalCard
      open={openModal}
      handleClose={() => {
        setOpenModal(null);
      }}
      width="40%"
    >
      <ModalCardWithHeaderFooter title="Variance Details" hideFooter>
        <Stack gap={2}>
          <Grid container spacing={2} borderBottom={border25} pb={2}>
            <Grid item xs={6}>
              <InputPreview
                label={product?.variant1?.displayName}
                value={product?.variant1?.inputValue}
                hideBorder
              />
            </Grid>
            {product?.variant2 && (
              <Grid item xs={6}>
                <InputPreview
                  label={product?.variant2?.displayName}
                  value={product?.variant2?.inputValue}
                  hideBorder
                />
              </Grid>
            )}
            {product?.variant3 && (
              <Grid item xs={6}>
                <InputPreview
                  label={product?.variant3?.displayName}
                  value={product?.variant3?.inputValue}
                  hideBorder
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <InputPreview
                label="Description"
                value={product?.description}
                hideBorder
              />
            </Grid>
            <Grid item xs={4}>
              <InputPreview label="SKU ID" value={product?.skuId} hideBorder />
            </Grid>
            <Grid item xs={4}>
              <InputPreview
                label="Original Price"
                value={product?.originalPrice}
                hideBorder
              />
            </Grid>
            <Grid item xs={4}>
              <InputPreview
                label="Offer Price"
                value={product?.offerPrice}
                hideBorder
              />
            </Grid>
            <Grid item xs={3}>
              <ImagePreview
                label="Photo 1"
                value={product?.photo1}
                hideBorder
              />
            </Grid>
            <Grid item xs={3}>
              <ImagePreview
                label="Photo 2"
                value={product?.photo2}
                hideBorder
              />
            </Grid>
            <Grid item xs={3}>
              <ImagePreview
                label="Photo 3"
                value={product?.photo3}
                hideBorder
              />
            </Grid>
            <Grid item xs={3}>
              <ImagePreview
                label="Photo 4"
                value={product?.photo4}
                hideBorder
              />
            </Grid>
            <Grid item xs={6}>
              <InputPreview
                label="Product Weight(gms)"
                value={product?.productWeight}
                hideBorder
              />
            </Grid>
            <Grid item xs={6}>
              <InputPreview
                label="Shipping Weight(gms)"
                value={product?.netProductWeight}
                hideBorder
              />
            </Grid>
            <Grid item xs={4}>
              <InputPreview
                label="Length(mm)"
                value={product?.productLength}
                hideBorder
              />
            </Grid>
            <Grid item xs={4}>
              <InputPreview
                label="Width(mm)"
                value={product?.productWidth}
                hideBorder
              />
            </Grid>
            <Grid item xs={4}>
              <InputPreview
                label="Height(mm)"
                value={product?.productHeight}
                hideBorder
              />
            </Grid>
            <Grid item xs={6}>
              <InputPreview
                label="QTY in Hand"
                value={product?.qty}
                hideBorder
              />
            </Grid>
            <Grid item xs={6}>
              <InputPreview
                label="Alert QTY"
                value={product?.alertQty}
                hideBorder
              />
            </Grid>
            <Grid item xs={6}>
              <InputPreview
                label="Min QTY Per Order"
                value={product?.minQty}
                hideBorder
              />
            </Grid>
            <Grid item xs={6}>
              <InputPreview
                label="Max QTY Per Order"
                value={product?.maxQty}
                hideBorder
              />
            </Grid>
          </Grid>
          <Typography sx={styles.title}>ONDC Variance</Typography>
          <Grid container spacing={2}>
            {product?.specList?.map((specItemInfo, specIndex) => (
              <Grid item xs={6} key={specIndex}>
                <InputPreview
                  label={specItemInfo?.displayName}
                  value={specItemInfo?.inputValue}
                  hideBorder
                />
              </Grid>
            ))}
          </Grid>
        </Stack>
      </ModalCardWithHeaderFooter>
    </ModalCard>
  );
}

export default VariantDataPreviewPopup;

const styles = {
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    mb: "-6px",
    color: blackShade19,
  },
};
